// extracted by mini-css-extract-plugin
export default {"meta":"Meta-module--meta--dae0a","meta__date":"Meta-module--meta__date--0c1b6"};